export default __webpack_public_path__ + "static/media/1-5-2.fed3c6a8.jpg";